import PropTypes from 'prop-types';
import { VXPay } from '../../utils/VXPay';
import Constants, { getTypeByColor } from './Constants';
import Translations from '../../utils/Translations';
import Flux from '../../flux/Flux';
import Alert, { BUTTON } from '../Alert/Alert';
import { Component } from 'react';

class StatusBarAVSStatus extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: this.props.isVisible,
			rejectMessage: this.props.options.rejectMessage,
		};

		this.onButtonClick = this.onButtonClick.bind(this);
		this.onNotificationChange = this.onNotificationChange.bind(this);
	}

	componentDidMount() {
		Flux.Notification.addNotificationChangeListener(this.onNotificationChange);
	}

	componentWillUnmount() {
		Flux.Notification.removeNotificationChangeListener(this.onNotificationChange);
	}

	onNotificationChange(notification) {
		switch (notification.type) {
			case Flux.Constants.ApiTypes.Notification.Incoming.AVS_PENDING:
			case Flux.Constants.ApiTypes.Notification.Incoming.AVS_REJECTED:
				this.setState({
					rejectMessage: notification.message,
				});
				break;
			default:
		}
	}

	onButtonClick() {
		VXPay.openAVS();
	}

	render() {
		if (!this.state.isVisible) {
			return null;
		}
		const { rejectMessage } = this.state;
		const text = rejectMessage ? Translations.get('StatusBarAVSRejectedOutro', rejectMessage) : Translations.get('StatusBarAVSPendingOutro');

		return (
			<Alert
				type={getTypeByColor(this.props.barColor)}
				text={text}
				buttons={[{ type: BUTTON.SECONDARY, text: Translations.get('StatusBarAVSRejectedButtonLbl'), onClick: this.onButtonClick }]}
			/>
		);
	}
}

StatusBarAVSStatus.propTypes = {
	barColor: PropTypes.string.isRequired,
	isVisible: PropTypes.bool.isRequired,
	options: PropTypes.arrayOf(PropTypes.string),
};

StatusBarAVSStatus.defaultProps = {
	barColor: Constants.BARCOLOR_WHITE,
};

export default StatusBarAVSStatus;
